(() => {
  const boot = (root = document) => {
    const revealItems = [...root.querySelectorAll('[data-dn-reveal]:not([data-dn-v3-reveal-ready])')];
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
      revealItems.forEach((item) => item.classList.add('is-visible'));
    } else if (revealItems.length) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      }, { threshold: 0.1, rootMargin: '0px 0px -5% 0px' });
      revealItems.forEach((item) => {
        item.dataset.dnV3RevealReady = 'true';
        observer.observe(item);
      });
    }

    root.querySelectorAll('[data-dn-v3-hero]').forEach((hero) => {
      if (hero.dataset.dnV3Ready) return;
      hero.dataset.dnV3Ready = 'true';
      if (!window.matchMedia('(pointer: fine)').matches || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      hero.addEventListener('pointermove', (event) => {
        const rect = hero.getBoundingClientRect();
        hero.style.setProperty('--dn-v3-mx', `${event.clientX - rect.left}px`);
        hero.style.setProperty('--dn-v3-my', `${event.clientY - rect.top}px`);
      });
    });

    root.querySelectorAll('[data-dn-v3-divisions]').forEach((section) => {
      if (section.dataset.dnV3Ready) return;
      section.dataset.dnV3Ready = 'true';
      const buttons = [...section.querySelectorAll('[data-dn-v3-switch]')];
      const panels = [...section.querySelectorAll('[data-dn-v3-panel]')];
      buttons.forEach((button) => {
        button.addEventListener('click', () => {
          const target = button.dataset.dnV3Switch;
          buttons.forEach((item) => {
            const selected = item === button;
            item.classList.toggle('is-selected', selected);
            item.setAttribute('aria-selected', selected ? 'true' : 'false');
          });
          panels.forEach((panel) => panel.classList.toggle('is-selected', panel.dataset.dnV3Panel === target));
          panels.filter((panel) => panel.dataset.dnV3Panel === target).forEach((panel) => panel.querySelectorAll('[data-dn-reveal]').forEach((item) => item.classList.add('is-visible')));
        });
      });
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot(), { once: true });
  else boot();
  document.addEventListener('shopify:section:load', (event) => boot(event.target));
})();
